<div class="w-100 nibedon-dtls-container" *ngIf="data">
  <div class="d-flex justify-content-center py-3" *ngIf="!isMobile">
    <div class="grab-handle"></div>
  </div>
  <div class="border-line" [ngClass]="{
    'solver-border': data.status === 'SOLVER PENDING',
    'response-pending-border': data.status === 'RESPONSE PENDING',
    'resolved-border': data.status === 'RESOLVED',
    'solved-border': data.status === 'SOLVED',
    'open-border': data.status === 'OPEN'
  }"></div>
  <div class="d-flex justify-content-between align-items-center px-4" [ngClass]="colorForStatus(data?.status,'bg')">

    <div class="d-flex align-items-center">
      <span class="nibedon-id-text">{{ data.nivedanCode }}</span>

      <button class="d-flex align-items-center status-btn ms-3" [ngClass]="colorForStatus(data?.status,'font')">
        {{ data.status }}
      </button>

    </div>
    <div class="d-flex" style="gap: 10px;">
      <img src="../../../../assets/comment.svg" (click)="showComment()">
      <img src="/assets/cross-white.svg" style="color: var(--text-primary);" alt="cross-icon" class="cursor-pointer"
        (click)="closeDialog()" />
    </div>
  </div>



  <!-- <div class="show-comment"> -->
    <!-- <div class="comment-title">Comment*</div>
    <div class="comment">
      <span class="comment-txt">{{conCatComment}}<a
        class="read-more" 
        (click)="showComment()">Read
        more</a></span>
      </div> -->
      <!-- <span class="read-more" (click)="showComment()">Read Comments<img src="../../../../assets/comment.svg"></span>
    </div> -->
    <!-- <div class="d-flex nibedon-dtls-gap p-3" style="flex-wrap: wrap;">
    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">Date & Time: </span>
      <span class="nibedon-dtls-value">{{ data.createdTimeStamp | date:"d MMM yy | hh:mm a" }}</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">Name: </span>
      <span class="nibedon-dtls-value">{{ data.devotee.firstName }} {{ data.devotee.lastName }}</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">Mobile Number: </span>
      <span class="nibedon-dtls-value">{{ data.phoneNumber }}</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">Family Code: </span>
      <span class="nibedon-dtls-value">{{ data.devotee.familyCode }}</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">State: </span>
      <span class="nibedon-dtls-value">{{ data.devotee.state }}</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">District/Town: </span>
      <span class="nibedon-dtls-value">{{ data.devotee.dist }}</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">PIN Code: </span>
      <span class="nibedon-dtls-value">{{ data.devotee.pin }}</span>
    </div>

    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">Initiated: </span>
      <span class="nibedon-dtls-value">{{ data.devotee.initiated }}</span>
    </div>
    <div class="d-flex align-items-center">
      <span class="nibedon-dtls-key">Swastayni: </span>
      <span class="nibedon-dtls-value">{{ data.devotee.swastayani }}</span>
    </div>
  </div>
  <div class="d-flex flex-column">
    <span class="nibedon-dtls-key">Nibedon: </span>
    <span class="nibedon-dtls-value">{{ data.nivedanDetails }}</span>
  </div> -->
    <!-- <div class="d-flex align-items-center">
        <span class="nibedon-dtls-key">Initiated :</span>
        <span class="nibedon-dtls-value">Yes</span>
      </div>
      <div class="d-flex align-items-center">
        <span class="nibedon-dtls-key">Swastayni :</span>
        <span class="nibedon-dtls-value">No</span>
      </div> -->

                <div class="content1">
                <div class="firstSection">
                    <div class="comment-div">
                        <div class="section-child">
                            <span class="nibedon-dtls-key">Date & Time :</span>
                            <span class="nibedon-dtls-value">{{data?.createdTimeStamp | date: "dd/MM/yy | hh:mma"}}</span>
                        </div>
                        <!-- <button class="btn-create-new" (click)="openCommentDialog()" *ngIf="acceptDataToShow?.status!=='RESOLVED'">
                            <img src="/assets/plus-normal.svg" alt="plus-icon">
                            <span>Add Comment</span>
                        </button> -->
                    </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">Name :</span>
                        <span class="nibedon-dtls-value">{{data?.devotee?.firstName+"
                            "+data?.devotee?.lastName}}</span>
                    </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">Mobile Number :</span>
                        <!-- <div class="call" (click)="getCall($event, acceptDataToShow?.phoneNumber)"> -->
                            <span class="nibedon-dtls-value">{{data?.phoneNumber}}</span>
                            <!-- <img src="/assets/callBack.svg" alt="callImg" style="width: 20px; height: 20px;"> -->
                        </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">Alternate Mobile Number :</span>
                        <div class="call">
                            <span class="nibedon-dtls-value">{{data?.alternatePhoneNumber || '--'}}</span>
                            <!-- <img *ngIf="acceptDataToShow?.alternatePhoneNumber" src="/assets/callBack.svg" alt="callImg"
                                style="width: 20px; height: 20px;"
                                (click)="getCall($event, acceptDataToShow?.alternatePhoneNumber)"> -->
                        </div>
                    </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">Famliy Code :</span>
                        <span class="nibedon-dtls-value">{{data?.devotee?.familyCode}}</span>
                    </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">State :</span>
                        <span class="nibedon-dtls-value">{{data?.devotee?.state}}</span>
                    </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">District / Town :</span>
                        <span class="nibedon-dtls-value">{{data?.devotee?.dist}}</span>
                    </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">Pincode :</span>
                        <span class="nibedon-dtls-value">{{data?.devotee?.pin}}</span>
                    </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">Initiated :</span>
                        <span class="nibedon-dtls-value">{{data?.devotee?.initiated || 'No'}}</span>
                    </div>

                    <div class="section-child">
                        <span class="nibedon-dtls-key">Swastayani :</span>
                        <span class="nibedon-dtls-value">{{data?.devotee?.swastayani || 'No'}}</span>
                    </div>

                    <!-- <div style="padding-bottom: 50px;"></div> -->
                    
                </div>
                <div class="second-section">
                    <div class="second-child">
                        <span class="nibedon-dtls-key">Nibedon:</span>
                        <span class="nibedon-dtls-value remove-n">{{data?.nivedanDetails}}</span>
                    </div>

                </div>

            </div>
  <div class="btn-div" style="padding: 14px;">
  <button class="btn-create-new" (click)="commentDialog()" *ngIf="data?.status!=='RESOLVED'">
    <img src="/assets/plus-normal.svg" alt="plus-icon">
    <span>Add Comment</span>
  </button>
  </div>
  <div class="d-flex justify-content-center dialog-footer" *ngIf="!isMobile">
    <button class="btn-track">
      <span class="me-1"> Track Nibedon Status</span>
      <img src="/assets/mobile-arrow-right.svg" />
    </button>
  </div>

</div>
<div class="blur-backdrop" *ngIf="isPrint"></div>
<div class="comment-overlay" *ngIf="isPrint">
  <div class="comment-box">
    <div class="comment-header">
      <span class="title3">All Comments <img src="../../../../assets/comment.svg"></span>
      <div class="cross" (click)="closeComment()">
        <img src="../../../../assets/cross-white.svg" alt="crossImg">
      </div>
    </div>
    <div class="comment-div">
      <div class="each-div" *ngFor="let item of commentArr">

        <span class="title2">{{item.updatedBy?.firstName + ' ' + item.updatedBy?.lastName}} |
          {{item.statusUpdateTimeStamp | date:'dd/MM/yy hh:mma'}}</span>
        <span class="drop-title">{{item.comment}}</span>
        <!-- <span class="drop-title">Verify Otp*</span> -->
        <!-- <input type="text" class="date-inp" placeholder="Enter the otp" [formControl]="comment"> -->
      </div>
    </div>
  </div>
</div>